var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./newsletter-modal.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4bc8bfb9\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./newsletter-modal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/home/components/newsletter-modal/newsletter-modal.vue
// module id = 266
// module chunks = 0